import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';


function Faq() {
  const { t } = useTranslation();
  const [openItems, setOpenItems] = useState(new Set());

  const toggleItem = (itemId) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(itemId)) {
      newOpenItems.delete(itemId);
    } else {
      newOpenItems.add(itemId);
    }
    setOpenItems(newOpenItems);
  };

  const allFaqs = [
    {
      id: "One",
      heading: "headingOne",
      collapse: "collapseOne",
      questionKey: "faq.question1",
      answerKey: "faq.answer1"
    },
    {
      id: "two",
      heading: "headingtwo",
      collapse: "collapsetwo",
      questionKey: "faq.question2",
      answerKey: "faq.answer2"
    },
    {
      id: "three",
      heading: "headingthree",
      collapse: "collapsethree",
      questionKey: "faq.question3",
      answerKey: "faq.answer3"
    },
    {
      id: "four",
      heading: "headingfour",
      collapse: "collapsefour",
      questionKey: "faq.question4",
      answerKey: "faq.answer4"
    },
    {
      id: "five",
      heading: "headingfive",
      collapse: "collapsefive",
      questionKey: "faq.question5",
      answerKey: "faq.answer5"
    },
    {
      id: "six",
      heading: "headingsix",
      collapse: "collapsesix",
      questionKey: "faq.question6",
      answerKey: "faq.answer6"
    },
    {
      id: "seven",
      heading: "headingseven",
      collapse: "collapseseven",
      questionKey: "faq.question7",
      answerKey: "faq.answer7"
    },
    {
      id: "eight",
      heading: "headingeight",
      collapse: "collapseeight",
      questionKey: "faq.question8",
      answerKey: "faq.answer8"
    },
    {
      id: "nine",
      heading: "headingnine",
      collapse: "collapsenine",
      questionKey: "faq.question9",
      answerKey: "faq.answer9"
    },
    {
      id: "ten",
      heading: "headingten",
      collapse: "collapseten",
      questionKey: "faq.question10",
      answerKey: "faq.answer10"
    }
  ];

  const leftColumnFaqs = allFaqs.slice(0, 5);
  const rightColumnFaqs = allFaqs.slice(5);

  return (
    <>

      <section className="faq faq-sec-home">
        <div className="container">
          <h3 className="heading">
            <span dangerouslySetInnerHTML={{ __html: t('FAQ') }} />
          </h3>

          <div id="mainAccordion">
            <div className="row">
             
              <div className="col-sm-6">
                {leftColumnFaqs.map((item, i) => (
                  <div className="card" key={i}>
                    <div className="card-header" id={item.heading}>
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          onClick={() => toggleItem(item.id)}
                          aria-expanded={openItems.has(item.id)}
                          aria-controls={item.collapse}
                        >
                          {t(item.questionKey)}
                          <span className={`plus ${openItems.has(item.id) ? 'd-none' : ''}`}>
                            <img src="images/icon-down.svg" alt="Expand" />
                          </span>
                          <span className={`minus ${openItems.has(item.id) ? '' : 'd-none'}`}>
                            <img src="images/icon-up.svg" alt="Collapse" />
                          </span>
                        </button>
                      </h5>
                    </div>
                    <div
                      id={item.collapse}
                      className={`collapse ${openItems.has(item.id) ? 'show' : ''}`}
                      aria-labelledby={item.heading}
                    >
                      <div className="card-body">
                        {item.id === "six" ? (
                          <Trans i18nKey={item.answerKey} components={{ 0: <a href="mailto:contact@roam4less.app" style={{ color: '#ff7400', textDecoration: 'underline' }} /> }} />
                        ) : (
                          t(item.answerKey)
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

             
              <div className="col-sm-6">
                {rightColumnFaqs.map((item, i) => (
                  <div className="card" key={i}>
                    <div className="card-header" id={item.heading}>
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          onClick={() => toggleItem(item.id)}
                          aria-expanded={openItems.has(item.id)}
                          aria-controls={item.collapse}
                        >
                          {t(item.questionKey)}
                          <span className={`plus ${openItems.has(item.id) ? 'd-none' : ''}`}>
                            <img src="images/icon-down.svg" alt="Expand" />
                          </span>
                          <span className={`minus ${openItems.has(item.id) ? '' : 'd-none'}`}>
                            <img src="images/icon-up.svg" alt="Collapse" />
                          </span>
                        </button>
                      </h5>
                    </div>
                    <div
                      id={item.collapse}
                      className={`collapse ${openItems.has(item.id) ? 'show' : ''}`}
                      aria-labelledby={item.heading}
                    >
                      <div className="card-body">
                        {item.id === "six" ? (
                          <Trans i18nKey={item.answerKey} components={{ 0: <a href="mailto:contact@roam4less.app" style={{ color: '#ff7400', textDecoration: 'underline' }} /> }} />
                        ) : (
                          t(item.answerKey)
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  );
}

export default Faq;
